import { render, staticRenderFns } from "./selectProduct.vue?vue&type=template&id=b204112c"
import script from "./selectProduct.vue?vue&type=script&lang=js"
export * from "./selectProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports